import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/products";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (value) => {
    return await axiosInstance(options).get(`${path}/details?_id=${value}`);
}

export const Status = async (values) => {
    return await axiosInstance(options).patch(`${path}/change-status`, values);
};

export const Delete = async (values) => {
  if (values && values.ids) {
    return await axiosInstance(options).delete(`${path}/delete?ids=${encodeURIComponent(JSON.stringify(values.ids))}`, { data: values });
  }
  const id = values?._id || values;
  return await axiosInstance(options).delete(`${path}/delete?_id=${id}`, values);
}

export const Edit = async (values) => {
    return await axiosInstance(options).post(`${path}/edit`, values);
}



